import React, { useState } from 'react';
import './header.scss';
import '../../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import '../../../helper.scss';
import {convertToUpperCase} from '../../Utils/ToUpperCase/to-upper-case.tsx';
import anytrakkLogo from '../../../assets/anytrakk.png';

const Header = () => {
  const [isOpen, toggleOpen] = useState(false);
  const menuClass = `dropdown-menu${isOpen ? " show" : ""}`;
  const storedUserDetails = localStorage.getItem("userdetails");
  const userDetails = storedUserDetails ? JSON.parse(storedUserDetails) : null;
   const userName = userDetails ? userDetails.user.name.replace(/^"(.*)"$/, '$1') : null;
    const userRole = convertToUpperCase(userDetails ? userDetails.role : null);

  return (
    <nav className="navbar fixed-top header-navbar">
      <div className="header-left">
        <img
          src={anytrakkLogo}
          alt="anytrakk_logo"
          className="header-logo"
        />
      </div>

      <div className="header-right">
        <div className="dropdown" onClick={() => toggleOpen(prev => !prev)}>
          <button
            className="btn dropdown-toggle"
            style={{
              background: 'linear-gradient(1turn, rgb(211, 211, 211), rgb(255, 255, 255))',
              color: 'black',
              border: 'none',
              fontWeight: 'bold',
              height: '35px'
            }}
          >
            <i className="fas fa-user-circle"></i>&nbsp; {userName}
          </button>

          <ul className={menuClass}>
            <li><a className="dropdown-item" href="#profile">Profile</a></li>
            <li><a className="dropdown-item" href="#/settings">Settings</a></li>
            <li>
              <a
                className="dropdown-item"
                href="/"
                onClick={() => localStorage.clear()}
              >
                Logout
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Header;
